<div class="row mt-3">
  <div class="col">
    <h5>Bypass Removal</h5>
  </div>

  <div class="col d-flex justify-content-end">
    <div
      class="d-flex justify-content-end"
      *ngIf="form?.formVersion?.eB2?.permanentBypassReason"
    >
      <span class="yellow-bg justification">
        {{ getMessage("EB_Permanent_Bypass_Justification").description
        }}<span class="bold ml-2">{{
          form?.formVersion?.eB2?.permanentBypassReason
        }}</span>
      </span>
    </div>
    <div class="pb-2 pr-2">
      <extra-action-button
        *ngFor="let action of section4ExtraActions"
        [extraAction]="action"
        [confirm]="true"
        [form]="form"
        [disabled]="disabled"
        (error)="alert.defaultError()"
      ></extra-action-button>
    </div>
  </div>
</div>
<!-- EB amendment approvals belong to the installation workflow and are rendered by section 3. -->
<form-workflow
  [form]="form"
  [sectionNumber]="4"
  [service]="service"
>
</form-workflow>
<!--
<div class="mt-3 sectionx" id="section4">
  <div class="row">
    <div class="col d-flex align-items-end">
      <h5 id="Section4Title">Bypass Removal</h5>
    </div>
    <div class="col d-flex justify-content-end">
      <div
        class="d-flex justify-content-end"
        *ngIf="form?.formVersion?.eB2?.permanentBypassReason"
      >
        <span class="yellow-bg justification">
          {{ getMessage("EB_Permanent_Bypass_Justification").description
          }}<span class="bold ml-2">{{
            form?.formVersion?.eB2?.permanentBypassReason
          }}</span>
        </span>
      </div>
      <div class="pb-2 pr-2">
        <extra-action-button
          *ngFor="let action of section4ExtraActions"
          [extraAction]="action"
          [confirm]="true"
          [form]="form"
          [disabled]="disabled"
          (error)="alert.defaultError()"
        ></extra-action-button>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-center">
    <div *ngFor="let s of section41Signatures" class="btn-sign-container mx-1">
      <button-signature
        *ngIf="s.enabled"
        #btnSign
        [roleId]="s.roles"
        [roleCodes]="s.roleCodes"
        [userNames]="s.userNames"
        [user]="s.approvedBy"
        [title]="s.name"
        [disable]="s.disabled"
        [value]="s.approved"
        [showApprove]="s.approveAction"
        [showUnapprove]="s.unapproveAction"
        [showDisapprove]="s.disapproveAction"
        [showCancel]="s.cancel"
        [cancelID]="s.cancelID"
        [date]="s.approvedOn"
        [taskID]="s.taskId"
        [enabled]="s.enabled"
        (approve)="service?.confirmSign(form, s, s.approveActionId)"
        (unapprove)="service?.sign(form, s.taskId, s.unapproveActionId)"
        (disapprove)="
          service?.sign(form, s.taskId, s.disapproveActionId, $event.text)
        "
        (onError)="alert.error($event)"
      ></button-signature>
    </div>
  </div>

  <div class="d-flex justify-content-center">
    <div *ngFor="let s of section42Signatures" class="btn-sign-container mx-1">
      <button-signature
        *ngIf="s.enabled"
        #btnSign
        [roleId]="s.roles"
        [roleCodes]="s.roleCodes"
        [userNames]="s.userNames"
        [user]="s.approvedBy"
        [title]="s.name"
        [disable]="s.disabled"
        [value]="s.approved"
        [showApprove]="s.approveAction"
        [showUnapprove]="s.unapproveAction"
        [showDisapprove]="s.disapproveAction"
        [showCancel]="s.cancel"
        [cancelID]="s.cancelID"
        [date]="s.approvedOn"
        [taskID]="s.taskId"
        [enabled]="s.enabled"
        (approve)="service?.confirmSign(form, s, s.approveActionId)"
        (unapprove)="service?.sign(form, s.taskId, s.unapproveActionId)"
        (disapprove)="
          service?.sign(form, s.taskId, s.disapproveActionId, $event.text)
        "
        (onError)="alert.error($event)"
      ></button-signature>
    </div>
  </div>
</div>
-->
